import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import { grey } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import { useCommonStyles } from '../../Styles';
import {
	ck_u_password,
	ck_u_username,
	defDateFormat,
	empty,
	req_cust,
	req_delete_file,
	req_module_setting,
	req_report_stocktake,
	req_salesman,
	req_stock,
	req_stocktake_report,
	req_stocktake_report2,
	stock_take_report_url,
	stock_take_report_url2,
	req_cust_area,
	req_mobile_module_setting,
	req_cust_category,
	req_cust_chain,
	req_stock_category,
	req_stock_brand,
	req_settings_branches,
	req_stocktake_uom,
	req_stock_take_editqty
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, { axiosDefaultConfig, axiosURIencode } from '../../Services/API_Service';
import { useSnackbar } from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import useCookieHook from "../../Services/useCookieHook";
import MUIDataTable from 'mui-datatables';
import {IconButton, Tooltip, Backdrop, CircularProgress, Switch, FormControlLabel, Box, Grid, TextField, Paper} from '@material-ui/core';
import {Assessment as AssessmentIcon, Edit as EditIcon, Check as CheckIcon, Close as CloseIconAction} from '@material-ui/icons';
import {de, getSetting} from '../../Helper/Helper';
import useColumnPreference from '../../Services/useColumnPreference';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import GenerateView from '../../Components/GenerateView';
import ExportColumnDialog from '../../Components/ExportColumnDialog';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	}, card: {
		maxWidth: 200,
		minWidth: 200,
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	textleft: {
		textAlign: "left"
	},
	dropzone: {
		width: '50%',
		borderRadius: 5
	},
	dropzoneText: {
		color: grey[600]
	},
	adverPaper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: theme.spacing(1.5)
	},
	adverView: {
		display: 'flex',
		flexWrap: 'wrap',
		padding: theme.spacing(1)
	},
	textarea: {
		width: '100%'
	},
	dateBtn: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	statusBtn: {
		marginLeft: 30,
		width: 150
	},
	row: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center'
	},
	alignRight: {
		display: 'flex',
		marginBottom: 10,
		flex: 1,
		flexDirection: 'row'
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
	qtyInput: {
		width: 80,
		'& input': {
			textAlign: 'right',
			color: 'inherit'
		},
		'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
			filter: 'invert(1)'
		}
	},
	actionCell: {
		display: 'flex',
		alignItems: 'center',
		gap: 4
	},
	actionIcon: {
		padding: 4,
		'& .MuiIconButton-label': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		},
		'& .MuiSvgIcon-root': {
			display: 'block'
		}
	},
	skeletonToolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(2, 3)
	},
	skeletonToolbarActions: {
		display: 'flex',
		gap: 8
	},
	skeletonTableHeader: {
		display: 'flex',
		gap: 16,
		padding: theme.spacing(1, 3),
		borderBottom: `1px solid ${theme.palette.divider}`
	},
	skeletonRow: {
		display: 'flex',
		gap: 16,
		padding: theme.spacing(1.25, 3),
		borderBottom: `1px solid ${theme.palette.divider}`
	},
	skeletonCell: {
		flex: 1
	}
}));

export default function RStockTake() {
	const tableHead = [
		{
			name: "st_dtl_id",
			label: "DTL ID",
			options: {
				display: false,
				filter: false,
				viewColumns: false
			}
		},
		{
			name: "st_id",
			label: "Stock Take ID",
			options: {
				display: false
			}
		},
		{
			name: "checkin_date",
			label: "Check-In Date",
			options: {
				display: true,
				customBodyRender: (value) => toIsoDate(value)
			}
		},
		{
			name: "staff_code",
			label: "Agent Code",
			options: {
				display: true
			}
		},
		{
			name: "name",
			label: "Agent Name",
			options: {
				display: true
			}
		},
		{
			name: "cust_code",
			label: "Outlet Code",
			options: {
				display: true
			}
		},
		{
			name: "cust_company_name",
			label: "Outlet Name",
			options: {
				display: true
			}
		},
		{
			name: "cust_category_name",
			label: "Outlet Category",
			options: {
				display: true
			}
		},
		{
			name: "cust_chain_name",
			label: "Outlet Chain",
			options: {
				display: true
			}
		},
		{
			name: "cust_area",
			label: "Outlet Area",
			options: {
				display: false
			}
		},
		{
			name: "product_code",
			label: "Item Code",
			options: {
				display: false
			}
		},
		{
			name: "product_name",
			label: "Item Name",
			options: {
				display: true
			}
		},
		{
			name: "product_barcode",
			label: "Item Barcode",
			options: {
				display: false
			}
		},
		{
			name: "prod_category_name",
			label: "Item Category",
			options: {
				display: false
			}
		},
		{
			name: "prod_brand_name",
			label: "Item Brand",
			options: {
				display: true
			}
		},
		{
			name: "unit_uom",
			label: "UOM",
			options: {
				display: true
			}
		},
		{
			name: "uom_barcode",
			label: "UOM Barcode",
			options: {
				display: false
			}
		},
		{
			name: "current_quantity",
			label: "Current QTY",
			options: {
				display: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					switch (value) {
						case '1888888':
							return 'High';
						case '1555555':
							return 'Medium';
						case '1111111':
							return 'Low';
						case '-111111':
							return '';
						default:
							return value;
					}
				}
			}
		},
		{
			name: "suggested_quantity",
			label: "Proposed QTY",
			options: {
				display: false
			}
		},
		{
			name: "suggest_return",
			label: "Return QTY",
			options: {
				display: false
			}
		},
		{
			name: "suggest_transfer",
			label: "Transfer QTY",
			options: {
				display: false
			}
		},
		{
			name: "expiry_date",
			label: "Expiry Date",
			options: {
				display: true,
				customBodyRender: (value, tableMeta, updateValue) => toExpiryDate(value)
			}
		},
		{
			name: "delist",
			label: "Listing",
			options: {
				display: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value === '-111111') {
						return 'Delist';
					}
					if (value === 'new') {
						return 'New';
					}
					return '';
				}
			}
		},
		{
			name: "rsp",
			label: "RSP",
			options: {
				display: true
			}
		},
		{
			name: "sos",
			label: "SOS",
			options: {
				display: true
			}
		},
		{
			name: "shelf_level",
			label: "Shelf Level",
			options: {
				display: true
			}
		},
		{
			name: "sp_remark",
			label: "Remark",
			options: {
				display: true
			}
		}
	];
	const commonStyle = useCommonStyles();
	const classes = useStyles();
	const singleton = PersistantData.getInstance();
	const [gState, setGState] = useContext(AppContext);
	var { translation: language, client } = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}
	const [cookies, setCookie] = useCookieHook([ck_u_username, ck_u_password]);

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const [splist, setSPlist] = useState([]);
	const [itemList, setItemList] = useState([]);
	const [outletList, setOutletList] = useState([]);
	const [stList, setStList] = useState([]);
	const [stList2, setStList2] = useState([]);
	const listRef = useRef({ stList: [], stList2: [] });
	listRef.current.stList = stList;
	listRef.current.stList2 = stList2;

	const [stockTakeDateRange, setStockTakeDateRange] = useState({});
	const [openStockTakeDateDoc, setOpenStockTakeDateDoc] = useState(false);
	const [stockTakeSpView, setStockTakeSpView] = useState(false);
	const [stockTakeOutletView, setStockTakeOutletView] = useState(false);
	const [stockTakeOutlet, setStockTakeOutlet] = useState(empty);
	const [stockTakeOutletSelect, setStockTakeOutletSelected] = useState(empty);
	const [stockTakeSpSelect, setStockTakeSpSelected] = useState(empty);
	const [stockTakeSalesperson, setStockTakeSalesperson] = useState(empty);
	const [stockTakeProductView, setStockTakeProductView] = useState(false);
	const [stockTakeProduct, setStockTakeProduct] = useState(empty);
	const [stockTakeProductSelect, setStockTakeProductSelected] = useState(empty);
	const [status, setStatus] = useState(1);
	const [itemStatusAnchor, setItemStatusAnchor] = useState(null);
	const [config, setConfig] = useState(0);
	const [printView, setPrintView] = useState(false);
	const [printView2, setPrintView2] = useState(false);
	const [tableHeader, setTableHeader] = useState([]);
	const { columns: preferredColumns1, onColumnViewChange: onPrefColumnViewChange1, isPreferenceLoaded: isPreferenceLoaded1 } = useColumnPreference('RStockTake_1', tableHeader, client);
	const { columns: preferredColumns2, onColumnViewChange: onPrefColumnViewChange2, isPreferenceLoaded: isPreferenceLoaded2 } = useColumnPreference('RStockTake_2', tableHeader, client);
	const [exportColumnView, setExportColumnView] = useState(false);
	const [pendingExportType, setPendingExportType] = useState('');
	const [areaList, setAreaList] = useState([]);
	const [areaView, setAreaView] = useState(false);
	const [selectedArea, setSelectedArea] = useState(empty);

	const [customerCategoryList, setCustomerCategoryList] = useState([]);
	const [customerChainList, setCustomerChainList] = useState([]);
	const [productCategoryList, setProductCategoryList] = useState([]);
	const [productBrandList, setProductBrandList] = useState([]);

	const [selectedCustomerCategory, setSelectedCustomerCategory] = useState(empty);
	const [selectedCustomerChain, setSelectedCustomerChain] = useState(empty);
	const [selectedProductCategory, setSelectedProductCategory] = useState(empty);
	const [selectedProductBrand, setSelectedProductBrand] = useState(empty);

	const [selectedCustomerCategoryValue, setSelectedCustomerCategoryValue] = useState(empty);
	const [selectedCustomerChainValue, setSelectedCustomerChainValue] = useState(empty);
	const [selectedProductCategoryValue, setSelectedProductCategoryValue] = useState(empty);
	const [selectedProductBrandValue, setSelectedProductBrandValue] = useState(empty);

	const [customerCategoryView, setCustomerCategoryView] = useState(false);
	const [customerChainView, setCustomerChainView] = useState(false);
	const [productCategoryView, setProductCategoryView] = useState(false);
	const [productBrandView, setProductBrandView] = useState(false);


	const [isLastStockCount, setIsLastStockCount] = useState(false);

	const [branchesList, setBranchesList] = useState([]);
	const hasBranch = branchesList.length > 0;
	const exportColumnSections = useMemo(() => buildExportColumnSections(language, hasBranch), [language, hasBranch]);
	const [branchesView, setBranchesView] = useState(false);
	const [branchSelectedValue, setBranchSelectedValue] = useState(empty);
	const [branchSelectedName, setBranchSelectedName] = useState(empty);
	const [uomExport, setUomExport] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [editingRowId, setEditingRowId] = useState(null);
	const [editingTable, setEditingTable] = useState(null);
	const editValuesRef = useRef({});
	const [isSaving, setIsSaving] = useState(false);
	const [isFetching, setIsFetching] = useState(false);


	useEffect(() => {
		if (JString(gState.client).isValid()) {
			getSalesmanList(gState.client);
			getOutletList(gState.client);
			loadStocksList(gState.client);
			loadConfig(gState.client);
			loadCustCategoryList(gState.client);
			loadCustChainList(gState.client);
			loadProdCategoryList(gState.client);
			loadBrand(gState.client);
			getAreaList(gState.client);
			getBranches(gState.client);
		}
	}, [gState.client, gState.translation]);

	useEffect(() => {
		const header = [...tableHead];
		if (branchesList.length > 0) {
			header.splice(5, 0, {
				name: "company",
				label: "Branch",
				options: {
					display: false,
					customBodyRender: (value) => value ? value.toUpperCase() : ''
				}
			});
		}
		setTableHeader(header);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [gState.translation, branchesList]);

	const loadConfig = (_client = client) => {
		API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			if (result == 1) {
				const _config = getSetting(extraData, 'customization', {});
				if (_config.rstocktake) {
					setConfig(_config.rstocktake);
				}
				if (_config.uomexport) {
					setUomExport(_config.uomexport);
				}

				const _modules = getSetting(extraData, 'modules', {});
				if (_modules['branch'] == true) {
					tableHead.splice(8, 0, {
						name: "company",
						label: "Branch",

						options: {
							display: false,
							customBodyRender: (value) => value ? value.toUpperCase() : ''
						}
					});
				}
			}
		});
		API_Service.get(req_mobile_module_setting, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			if (result == 1) {
				const { module, pdf_images } = extraData;
				const _st_notes = module.find((content) => content.module === 'app_stock_take_notes');
				if (_st_notes) {
					const { status } = _st_notes;
					let setting = JSON.parse(status);
					if (setting) {
						tableHead.splice(8, 0, {
							name: "top_up_qty",
							label: "Top Up QTY",
							options: {
								display: true
							}
						});
						tableHead.push({
							name: "note",
							label: "Note",
							options: {
								display: true
							}
						});
					}
				}
				// const _customization = module.find((content) => content.module === 'app_customization');
				// if (_customization) {
				// 	const {status} = _customization;
				// 	var customize_module = JSON.parse(status);

				// 	if (customize_module.hasOwnProperty('stockreturn') && customize_module.stockreturn) {
				// 		tableHead.splice(8, 0, {
				// 			name: "return_qty",
				// 			label: "Return Quantity",
				// 			options: {
				// 				display: true
				// 			}
				// 		});
				// 	}
				// }
			}
		});
	}

	const loadCustCategoryList = (_client = client) => {
		API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const { cust_category_id, cust_category_code, cust_category_name, cust_category_status } = extraData[i];
						if (parseInt(cust_category_status) === 1) {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 1
							});
						} else {
							_arr.push({
								name: cust_category_name,
								secondary: cust_category_code,
								value: cust_category_id,
								status: 0
							});
						}
					}
					setCustomerCategoryList(() => (_arr));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
	}

	const loadCustChainList = (_client = client) => {
		API_Service.get(req_cust_chain, axiosDefaultConfig(_client)).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const { cust_chain_id, cust_chain_code, cust_chain_name, cust_chain_status } = extraData[i];
						if (parseInt(cust_chain_status) === 1) {
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 1
							});
						} else {
							_arr.push({
								name: cust_chain_name,
								secondary: cust_chain_code,
								value: cust_chain_id,
								status: 0
							});
						}
					}
					setCustomerChainList(() => (_arr));
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}

	const loadProdCategoryList = (_client = client) => {
		API_Service.get(req_stock_category, axiosDefaultConfig(_client)).then(({ data }) => {
			if (!_.isEmpty(data)) {
				var _arr = [];
				for (let idx = 0; idx < data.length; idx++) {
					const { category_id, categoryIdentifierId, category_name, category_status } = data[idx];
					if (parseInt(category_status) === 1) {
						_arr.push({
							name: category_name,
							secondary: categoryIdentifierId,
							value: category_id,
							status: 1
						});
					} else {
						_arr.push({
							name: category_name,
							secondary: categoryIdentifierId,
							value: category_id,
							status: 0
						});
					}
				}
				setProductCategoryList(() => (_arr));
			} else {

			}
		});
	}

	const loadBrand = (_client = client) => {
		API_Service.get(req_stock_brand, axiosDefaultConfig(_client)).then(({ data }) => {
			var _arr = [];
			if (!_.isEmpty(data)) {
				for (let idx = 0; idx < data.length; idx++) {
					const { brand_id, brand_code, brand_name, brand_status } = data[idx];
					if (parseInt(brand_status) === 1) {
						_arr.push({
							name: brand_name,
							secondary: brand_code,
							value: brand_id,
							status: 1
						});
					} else {
						_arr.push({
							name: brand_name,
							secondary: brand_code,
							value: brand_id,
							status: 0
						});
					}
				}
			}
			setProductBrandList(() => (_arr));
		});
	}

	const getAreaList = (_client = client) => {
		API_Service.get(req_cust_area, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			if (parseInt(result) === 1) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const { area_name, area_code, area_status } = extraData[idx];
					_data.push({ name: area_name, secondary: area_code, value: area_code, status: parseInt(area_status) });
				}
				setAreaList(_data);
			}
		});
	}

	const AreaViewClick = () => {
		setAreaView(true);
	}

	const AreaViewClose = (newValue) => {
		setAreaView(false);
		if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setSelectedArea(value);
		}
	}

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const handleEditRow = (rowIndex, tableKey) => {
		const list = listRef.current[tableKey];
		const row = list[rowIndex];
		editValuesRef.current = {
			current_quantity: row.current_quantity || '',
			suggested_quantity: row.suggested_quantity || '',
			top_up_qty: row.top_up_qty || '',
			suggest_return: row.suggest_return || '',
			suggest_transfer: row.suggest_transfer || ''
		};
		setEditingRowId(row.st_dtl_id);
		setEditingTable(tableKey);
	};

	const handleCancelEdit = () => {
		editValuesRef.current = {};
		setEditingRowId(null);
		setEditingTable(null);
	};

	const handleSaveEdit = () => {
		const list = listRef.current[editingTable];
		const rowIndex = list.findIndex(item => item.st_dtl_id === editingRowId);
		if (rowIndex === -1) return;

		const editValues = editValuesRef.current;
		setIsSaving(true);
		const formdata = new FormData();
		formdata.append('id', editingRowId);
		formdata.append('username', cookies(ck_u_username));
		['current_quantity', 'suggested_quantity', 'top_up_qty', 'suggest_return', 'suggest_transfer'].forEach(field => {
			if (editValues[field] !== undefined && editValues[field] !== '') {
				formdata.append(field, editValues[field]);
			}
		});

		API_Service.post(req_stock_take_editqty, formdata, axiosDefaultConfig(client))
			.then(({data}) => {
				if (data.result == 1) {
					const setter = editingTable === 'stList' ? setStList : setStList2;
					setter(prev => {
						const updated = [...prev];
						updated[rowIndex] = {...updated[rowIndex], ...editValues};
						return updated;
					});
					editValuesRef.current = {};
					setEditingRowId(null);
					setEditingTable(null);
					snack(language.record_updated, 'success');
				} else {
					snack(data.message || language.edit_qty_failed, 'error');
				}
				setIsSaving(false);
			})
			.catch(() => {
				snack(language.edit_qty_failed, 'error');
				setIsSaving(false);
			});
	};

	const applyEditableColumns = (columns, tableKey) => {
		const editableFields = ['current_quantity', 'suggested_quantity', 'top_up_qty', 'suggest_return', 'suggest_transfer'];
		const cols = columns.map((col) => {
			if (!editableFields.includes(col.name)) return col;
			const originalRender = col.options && col.options.customBodyRender;
			return {
				...col,
				options: {
					...col.options,
					customBodyRender: (value, tableMeta, updateValue) => {
						const list = listRef.current[tableKey];
						const rowData = list[tableMeta.rowIndex];
						if (rowData && rowData.st_dtl_id === editingRowId && editingTable === tableKey) {
							return (
								<QtyEditField
									key={editingRowId + '_' + col.name}
									field={col.name}
									valuesRef={editValuesRef}
									className={classes.qtyInput}
								/>
							);
						}
						if (originalRender) return originalRender(value, tableMeta, updateValue);
						return value;
					}
				}
			};
		});
		cols.push({
			name: "edit_actions",
			label: " ",
			options: {
				display: true,
				filter: false,
				sort: false,
				viewColumns: false,
				customBodyRender: (value, tableMeta) => {
					const list = listRef.current[tableKey];
					const rowData = list[tableMeta.rowIndex];
					if (!rowData) return null;
					const isEditing = rowData.st_dtl_id === editingRowId && editingTable === tableKey;
					if (isEditing) {
						return (
							<div className={classes.actionCell}>
								<Tooltip title={language.save || 'Save'}>
									<IconButton size="small" className={classes.actionIcon} onClick={(e) => { e.stopPropagation(); handleSaveEdit(); }} disabled={isSaving}>
										<CheckIcon fontSize="small" style={{color: 'green'}} />
									</IconButton>
								</Tooltip>
								<Tooltip title={language.cancel || 'Cancel'}>
									<IconButton size="small" className={classes.actionIcon} onClick={(e) => { e.stopPropagation(); handleCancelEdit(); }} disabled={isSaving}>
										<CloseIconAction fontSize="small" style={{color: 'red'}} />
									</IconButton>
								</Tooltip>
							</div>
						);
					}
					return (
						<Tooltip title={language.edit_quantity || 'Edit Quantity'}>
							<IconButton size="small" onClick={(e) => { e.stopPropagation(); handleEditRow(tableMeta.rowIndex, tableKey); }} disabled={editingRowId !== null}>
								<EditIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					);
				}
			}
		});
		return cols;
	};

	const editableColumns1 = useMemo(() => applyEditableColumns(config ? preferredColumns1.map(obj => {
		if (obj.name == "suggested_quantity") {
			obj.label = "Stock Transfer";
		}
		return obj;
	}) : preferredColumns1, 'stList'),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[preferredColumns1, config, editingRowId, editingTable, isSaving, language]);

	const editableColumns2 = useMemo(() => applyEditableColumns(config ? preferredColumns2.map(obj => {
		if (obj.name == "suggested_quantity") {
			obj.label = "Stock Transfer";
		}
		return obj;
	}) : preferredColumns2, 'stList2'),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[preferredColumns2, config, editingRowId, editingTable, isSaving, language]);

	const skeletonColumnCount = useMemo(() => {
		const source = isLastStockCount ? editableColumns2 : editableColumns1;
		const visible = source.filter(col => col.options && col.options.display !== false).length;
		return visible > 0 ? Math.min(visible, 10) : 8;
	}, [editableColumns1, editableColumns2, isLastStockCount]);

	const getBranches = (_client = client) => {
		API_Service.get(req_settings_branches, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			if (result) {
				setBranchesList(branchesList => (extraData));
			}
		}).catch(de);
	}

	const BranchesViewClose = (newValue) => {
		setBranchesView(false);
		if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setBranchSelectedValue(value);

			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					name += newValue[i].name;
				} else {
					name += newValue[i].name + ",";
				}
			}
			setBranchSelectedName(name);
		}
	}

	const getStockTake = (_client = client) => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(stockTakeDateRange)) {
			st_date = format(stockTakeDateRange.startDate, defDateFormat);
			st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
		}
		var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: stockTakeSpSelect,
			cust_code: stockTakeOutletSelect,
			cust_category_id: selectedCustomerCategoryValue,
			cust_chain_id: selectedCustomerChainValue,
			product_code: stockTakeProductSelect,
			prod_category_id: selectedProductCategoryValue,
			prod_brand_id: selectedProductBrandValue,
			status: status,
			area: selectedArea,
			username: cookies(ck_u_username),
		};
		if (gState.company) {
			parameters.company = gState.company;
		}
		if (branchSelectedValue !== empty) {
			parameters.company = JSON.stringify(branchSelectedValue.split(","));
		}
		const formdata = new FormData();
		Object.keys(parameters).forEach(key => formdata.append(key, parameters[key]));
		setIsFetching(true);
		API_Service.post(req_report_stocktake, formdata, axiosDefaultConfig(_client)).then(({ data }) => {
			const formatData = (data) => {
				return data.map(_arr => {
					if (_arr['checkin_time']) {
						_arr['checkin_date'] = toDisplayDate(_arr['checkin_time']);
						_arr['checkin_time'] = toDisplayTime(_arr['checkin_time']);
					}
					if (_arr['checkout_time']) {
						_arr['checkout_date'] = toDisplayDate(_arr['checkout_time']);
						_arr['checkout_time'] = toDisplayTime(_arr['checkout_time']);
					}
					_arr['created_date'] = toDisplayDate(_arr['created_date']);
					return _arr;
				});
			};

			const { result, extraData, extraData2 } = data;
			if (result) {
				setStList(formatData(extraData));
				setStList2(formatData(extraData2));
			} else {
				setStList([]);
				setStList2([]);
				snack(language.no_data, 'warning');
			}
			setIsFetching(false);
		}).catch(() => {
			setStList([]);
			setStList2([]);
			setIsFetching(false);
			snack(language.network_error, 'error');
		});
	}

	const getSalesmanList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const { name, login_id, login, login_status } = extraData[idx];
					_data.push({ name: name, secondary: login, value: login_id, status: parseInt(login_status) });
				}
				setSPlist(splist => (_data));
			}
		});
	}

	const getOutletList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_cust}${parameters}`, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			var { customer, inactive_customer } = extraData;
			if (parseInt(result) === 1) {
				var arr = [];
				for (let i = 0; i < customer.length; i++) {
					const { cust_code, cust_company_name } = customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_code,
						status: 1
					});
				}
				for (let i = 0; i < inactive_customer.length; i++) {
					const { cust_code, cust_company_name } = inactive_customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_code,
						status: 0
					});
				}
				setOutletList(arr);
			}
		});
	}

	const loadStocksList = (_client = client) => {
		var req = `${req_stock}-1`;
		API_Service.get(req, axiosDefaultConfig(_client)).then(({ data }) => {
			const { result, extraData } = data;
			const { stock: stockApi } = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const { product_name, product_code, product_status } = stockApi[idx];
					_data.push({ name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status) });
				}
				setItemList(itemList => (_data));
			}
		});
	}

	const StockTakeSPViewClick = () => {
		setStockTakeSpView(true);
	}

	const StockTakeSPViewClose = (newValue) => {
		setStockTakeSpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setStockTakeSpSelected(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setStockTakeSalesperson(spname);
		}
	}

	const StockTakeOutletViewClick = () => {
		setStockTakeOutletView(true);
	}

	const StockTakeOutletViewClose = (newValue) => {
		setStockTakeOutletView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setStockTakeOutletSelected(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setStockTakeOutlet(spname);
		}
	}

	const StockTakeProductViewClick = () => {
		setStockTakeProductView(true);
	}

	const StockTakeProductViewClose = (newValue) => {
		setStockTakeProductView(false);
		if (newValue) {
			var itemsvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsvalue += newValue[i].value;
				} else {
					itemsvalue += newValue[i].value + ",";
				}
			}
			setStockTakeProductSelected(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsname += newValue[i].name;
				} else {
					itemsname += newValue[i].name + ",";
				}
			}
			setStockTakeProduct(itemsname);
		}
	}

	const OnCloseCustomerCategoryView = (data) => {
		setCustomerCategoryView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedCustomerCategoryValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedCustomerCategory(itemsname);
		}
	}

	const OnCloseCustomerChainView = (data) => {
		setCustomerChainView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedCustomerChainValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedCustomerChain(itemsname);
		}
	}

	const OnCloseProductCategoryView = (data) => {
		setProductCategoryView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedProductCategoryValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedProductCategory(itemsname);
		}
	}

	const OnCloseProductBrandView = (data) => {
		setProductBrandView(false);
		if (data) {
			var itemsvalue = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsvalue += data[i].value;
				} else {
					itemsvalue += data[i].value + ",";
				}
			}
			setSelectedProductBrandValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < data.length; i++) {
				if (i == data.length - 1) {
					itemsname += data[i].name;
				} else {
					itemsname += data[i].name + ",";
				}
			}
			setSelectedProductBrand(itemsname);
		}
	}

	const getStockTakeDate = () => {
		return !_.isEmpty(stockTakeDateRange) ? moment(stockTakeDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(stockTakeDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

	const openPrintSelectView = () => {
		setPrintView(true);
	}

	const openPrintSelectView2 = () => {
		setPrintView2(true);
	}

	const printViewClose = (type) => {
		setPrintView(false);
		if (type === 'normal') {
			setPendingExportType(type);
			setExportColumnView(true);
		} else {
			generateStockTakeReport(type);
		}
	}

	const printViewClose2 = (type) => {
		setPrintView2(false);
		if (type === 'normal2') {
			setPendingExportType(type);
			setExportColumnView(true);
		} else {
			generateStockTakeReport(type);
		}
	}

	const onExportColumnsGenerate = (selectedKeys) => {
		setExportColumnView(false);
		generateStockTakeReport(pendingExportType, selectedKeys.join(','));
	}

	const submitReportForm = (url, fields) => {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = url.split('?')[0];
		form.target = '_blank';
		Object.keys(fields).forEach(key => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = key;
			input.value = fields[key];
			form.appendChild(input);
		});
		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	}

	const generateStockTakeReport = (type, exportColumns = '', _client = client) => {
		setIsLoading(true);
		if (type == 'simply') {
			var st_date = '';
			var st_date_to = '';
			if (!_.isEmpty(stockTakeDateRange)) {
				st_date = format(stockTakeDateRange.startDate, defDateFormat);
				st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
			}
			const date_range = `${st_date} to ${st_date_to}`;
			let branch = gState.company ? gState.company : '';
			if (branchSelectedValue !== empty) {
				branch = JSON.stringify(branchSelectedValue.split(","));
			}
			const json = JSON.stringify(preferredColumns1.length > 0 ? preferredColumns1 : tableHeader);
			submitReportForm(stock_take_report_url, {
				client: client,
				reportDate: date_range,
				salespersonId: stockTakeSpSelect,
				cust_code: stockTakeOutletSelect,
				product_code: stockTakeProductSelect,
				cust_category_id: selectedCustomerCategoryValue,
				cust_chain_id: selectedCustomerChainValue,
				prod_category_id: selectedProductCategoryValue,
				prod_brand_id: selectedProductBrandValue,
				branch: branch,
				json: json,
				username: cookies(ck_u_username),
			});
			setIsLoading(false);
		}
		if (type == 'normal') {
			var st_date = '';
			var st_date_to = '';
			if (!_.isEmpty(stockTakeDateRange)) {
				st_date = format(stockTakeDateRange.startDate, defDateFormat);
				st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
			}
			var parameters = {
				client: client,
				date_from: st_date,
				date_to: st_date_to,
				salespersonId: stockTakeSpSelect,
				cust_code: stockTakeOutletSelect,
				product_code: stockTakeProductSelect,
				cust_category_id: selectedCustomerCategoryValue,
				cust_chain_id: selectedCustomerChainValue,
				prod_category_id: selectedProductCategoryValue,
				prod_brand_id: selectedProductBrandValue,
				status: status,
				username: cookies(ck_u_username),
			};
			if (gState.company) {
				parameters.company = gState.company;
			}
			if (exportColumns) {
				parameters.columns = exportColumns;
			}
			const formdata = new FormData();
			Object.keys(parameters).forEach(key => formdata.append(key, parameters[key]));
			API_Service.post(req_stocktake_report, formdata, axiosDefaultConfig(_client))
				.then(({ data }) => {
					const { result, extraData } = data;
					if (result) {
						window.open(extraData.url, '_blank');
						const delay = setTimeout(() => {
							API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
							clearTimeout(delay);
						}, 5000);
					} else {
						snack(language.no_data, 'warning');
					}
					setIsLoading(false);
				}).catch(err => {
					snack('The data is too large, please simplify the requirements', 'warning');
					setIsLoading(false);
				});
		}
		if (type == 'uom') {
			var st_date = '';
			var st_date_to = '';
			if (!_.isEmpty(stockTakeDateRange)) {
				st_date = format(stockTakeDateRange.startDate, defDateFormat);
				st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
			}
			var parameters = {
				client: client,
				date_from: st_date,
				date_to: st_date_to,
				salespersonId: stockTakeSpSelect,
				cust_code: stockTakeOutletSelect,
				product_code: stockTakeProductSelect,
				cust_category_id: selectedCustomerCategoryValue,
				cust_chain_id: selectedCustomerChainValue,
				prod_category_id: selectedProductCategoryValue,
				prod_brand_id: selectedProductBrandValue,
				branch: branchSelectedValue,
				area: selectedArea,
				status: status,
				username: cookies(ck_u_username),
			};
			if (gState.company) {
				parameters.company = gState.company;
			}
			const formdata = new FormData();
			Object.keys(parameters).forEach(key => formdata.append(key, parameters[key]));
			API_Service.post(req_stocktake_uom, formdata, axiosDefaultConfig(_client))
				.then(({ data }) => {
					const { result, extraData } = data;
					if (result) {
						window.open(extraData.url, '_blank');
						const delay = setTimeout(() => {
							API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
							clearTimeout(delay);
						}, 5000);
					} else {
						snack(language.no_data, 'warning');
					}
					setIsLoading(false);
				}).catch(err => {
					snack('Export Excel Failed', 'warning');
					setIsLoading(false);
				});
		}

		if (type == 'simply2') {
			var st_date = '';
			var st_date_to = '';
			if (!_.isEmpty(stockTakeDateRange)) {
				st_date = format(stockTakeDateRange.startDate, defDateFormat);
				st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
			}
			const date_range = `${st_date} to ${st_date_to}`;
			const branch = gState.company ? gState.company : '';
			const json = JSON.stringify(preferredColumns2.length > 0 ? preferredColumns2 : tableHeader);
			submitReportForm(stock_take_report_url2, {
				client: client,
				reportDate: date_range,
				salespersonId: stockTakeSpSelect,
				cust_code: stockTakeOutletSelect,
				product_code: stockTakeProductSelect,
				cust_category_id: selectedCustomerCategoryValue,
				cust_chain_id: selectedCustomerChainValue,
				prod_category_id: selectedProductCategoryValue,
				prod_brand_id: selectedProductBrandValue,
				branch: branch,
				json: json,
				username: cookies(ck_u_username),
			});
			setIsLoading(false);
		}
		if (type == 'normal2') {
			var st_date = '';
			var st_date_to = '';
			if (!_.isEmpty(stockTakeDateRange)) {
				st_date = format(stockTakeDateRange.startDate, defDateFormat);
				st_date_to = format(stockTakeDateRange.endDate, defDateFormat);
			}
			var parameters = {
				client: client,
				date_from: st_date,
				date_to: st_date_to,
				salespersonId: stockTakeSpSelect,
				cust_code: stockTakeOutletSelect,
				product_code: stockTakeProductSelect,
				cust_category_id: selectedCustomerCategoryValue,
				cust_chain_id: selectedCustomerChainValue,
				prod_category_id: selectedProductCategoryValue,
				prod_brand_id: selectedProductBrandValue,
				status: status,
				username: cookies(ck_u_username),
			};
			if (gState.company) {
				parameters.company = gState.company;
			}
			if (exportColumns) {
				parameters.columns = exportColumns;
			}
			const formdata = new FormData();
			Object.keys(parameters).forEach(key => formdata.append(key, parameters[key]));
			API_Service.post(req_stocktake_report2, formdata, axiosDefaultConfig(_client)).then(({ data }) => {
				const { result, extraData } = data;
				if (result) {
					window.open(extraData.url, '_blank');
					const delay = setTimeout(() => {
						API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
						clearTimeout(delay);
					}, 5000);
				} else {
					snack(language.no_data, 'warning');
				}
				setIsLoading(false);
			}).catch(err => {
				snack('The data is too large, please simplify the requirements', 'warning');
				setIsLoading(false);
			});
		}
	}

	const handleSwitchChange = (event) => {
		setIsLastStockCount(event.target.checked);
	};

	return (
		<div>
			{/* <Typography className={classes.heading}>{ language.generate_stock_take_report }</Typography> */}
			<div className={classes.viewInRow}>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => StockTakeSPViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{stockTakeSalesperson ? _.truncate(stockTakeSalesperson, { length: 20 }) : language.salesperson}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => StockTakeOutletViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{stockTakeOutlet ? _.truncate(stockTakeOutlet, { length: 20 }) : language.customer}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => setCustomerCategoryView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedCustomerCategory ? _.truncate(selectedCustomerCategory, { length: 20 }) : "Outlet Category"}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => setCustomerChainView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedCustomerChain ? _.truncate(selectedCustomerChain, { length: 20 }) : "Outlet Chain"}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => AreaViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedArea ? _.truncate(selectedArea, { length: 20 }) : "Area"}
					</Typography>
				</Button>
				{
					!gState.company && branchesList.length > 0 && (
						<Button
							style={{ width: 300, marginRight: 10 }}
							variant="outlined"
							onClick={() => setBranchesView(true)}
							endIcon={<KeyboardArrowDownRoundedIcon />}>
							<Typography className={commonStyle.searchBtnFont}>
								{branchSelectedName ? _.truncate(branchSelectedName, { length: 20 }) : "Branch"}
							</Typography>
						</Button>
					)
				}
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => StockTakeProductViewClick()}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{stockTakeProduct ? _.truncate(stockTakeProduct, { length: 20 }) : language.items}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => setProductCategoryView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedProductCategory ? _.truncate(selectedProductCategory, { length: 20 }) : "Item Category"}
					</Typography>
				</Button>
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => setProductBrandView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon />}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedProductBrand ? _.truncate(selectedProductBrand, { length: 20 }) : "Item Brand"}
					</Typography>
				</Button>
				{/* <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					aria-controls="active-status-menu"
					aria-haspopup="true"
					onClick={event=>setItemStatusAnchor(event.currentTarget)}>
					{status === 1 ? language.active : language.inactive}
				</Button>
				<Menu
					id="active-status-menu"
					anchorEl={itemStatusAnchor}
					keepMounted
					open={Boolean(itemStatusAnchor)}
					onClose={()=>setItemStatusAnchor(null)}>
					<MenuItem style={{width: 300}} onClick={()=>{setItemStatusAnchor(null); setStatus(1);}}>{language.active}</MenuItem>
					<MenuItem style={{width: 300}} onClick={()=>{setItemStatusAnchor(null); setStatus(0);}}>{language.inactive}</MenuItem>
				</Menu> */}
				<Button
					style={{ width: 300, marginRight: 10 }}
					variant="outlined"
					onClick={() => setOpenStockTakeDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getStockTakeDate()}
					</Typography>
				</Button>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					disabled={isFetching}
					onClick={() => getStockTake()}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.view}
					</Typography>
				</Button>
			</div>
			<div style={{ height: 20 }} />
			{isFetching && <StockTakeTableSkeleton classes={classes} columnCount={skeletonColumnCount} rowCount={8} />}
			{
				!isFetching && isLastStockCount == false && stList.length > 0 && (
					<MUIDataTable
						title={language.stock_take}
						data={stList}
						columns={editableColumns1}
						options={{
							search: false,
							sortFilterList: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 25,
							rowsPerPageOptions: [25, 40, 65, 100],
							responsive: 'simple',
							onColumnViewChange: onPrefColumnViewChange1,
							customToolbar: () => (
								<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{ marginTop: -57, paddingRight: 60 }}>
									<Grid item style={{ marginTop: 4 }}>
										<FormControlLabel
											control={
												<Switch
													checked={false}
													onClick={handleSwitchChange}
													color="primary"
												/>
											}
											label="Last Stock Count"
											labelPlacement="start"
										/>
									</Grid>

									<Grid item>
										<CheckinTableReportButton onGenerateReport={openPrintSelectView} />
									</Grid>
								</Grid>
							)
						}}
					/>
				)
			}
			{
				!isFetching && isLastStockCount == true && stList2.length > 0 && (
					<MUIDataTable
						title={language.stock_take}
						data={stList2}
						columns={editableColumns2}
						options={{
							search: false,
							sortFilterList: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 25,
							rowsPerPageOptions: [25, 40, 65, 100],
							responsive: 'simple',
							onColumnViewChange: onPrefColumnViewChange2,
							customToolbar: () =>
								<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{ marginTop: -57, paddingRight: 60 }}>
									<Grid item style={{ marginTop: 4 }}>
										<FormControlLabel
											control={
												<Switch
													checked={true}
													onClick={handleSwitchChange}
													color="primary"
												/>
											}
											label="Last Stock Count"
											labelPlacement="start"
										/>
									</Grid>

									<Grid item>
										<CheckinTableReportButton onGenerateReport={openPrintSelectView2} />
									</Grid>
								</Grid>
						}}
					/>
				)
			}

			<VirtualListCB
				open={stockTakeSpView}
				setClose={data => StockTakeSPViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={stockTakeOutletView}
				setClose={data => StockTakeOutletViewClose(data)}
				title={"Outlet"}
				data={outletList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={stockTakeProductView}
				setClose={data => StockTakeProductViewClose(data)}
				title={"Product"}
				data={itemList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={areaView}
				setClose={data => AreaViewClose(data)}
				title={"Area"}
				data={areaList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={customerCategoryView}
				setClose={data => OnCloseCustomerCategoryView(data)}
				title={"Outlet Category"}
				data={customerCategoryList}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={customerChainView}
				setClose={data => OnCloseCustomerChainView(data)}
				title={"Outlet Chain"}
				data={customerChainList}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={productCategoryView}
				setClose={data => OnCloseProductCategoryView(data)}
				title={"Product Category"}
				data={productCategoryList}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={productBrandView}
				setClose={data => OnCloseProductBrandView(data)}
				title={"Product Brand"}
				data={productBrandList}
				language={language}
				filteration={1}
			/>

			<VirtualListCB
				open={branchesView}
				setClose={data => BranchesViewClose(data)}
				title={"Branch"}
				data={branchesList}
				language={language}
				filteration={0}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setStockTakeDateRange(range);
					setOpenStockTakeDateDoc(false)
				}}
				setNegative={() => {
					setOpenStockTakeDateDoc(false)
				}}
				setClose={() => {
					setOpenStockTakeDateDoc(false)
				}}
				open={openStockTakeDateDoc}
				message={language.date_range}
				positive={language.ok}
				negative={language.cancel}
			/>

			<GenerateView
				classes={{
					paper: commonStyle.listView,
				}}
				id="ringtone-menu"
				keepMounted
				open={printView}
				onClose={() => setPrintView(false)}
				onSelect={printViewClose}
				value={'simply'}
				title={language.generate_type || ''}
				language={language}
				options={[
					{ name: 'Basic Version', value: 'simply' },
					{ name: 'Detailed Version', value: 'normal' },
					...(uomExport === 1 ? [{ name: 'UOM Convertion Version', value: 'uom' }] : []),
				]}
			/>

			<Backdrop className={classes.backdrop} open={isLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>

			<GenerateView
				classes={{
					paper: commonStyle.listView,
				}}
				id="ringtone-menu"
				keepMounted
				open={printView2}
				onClose={() => setPrintView2(false)}
				onSelect={printViewClose2}
				value={'simply2'}
				title={language.generate_type || ''}
				language={language}
				options={[
					{ name: 'Basic Version', value: 'simply2' },
					{ name: 'Detailed Version', value: 'normal2' }
				]}
			/>

			<ExportColumnDialog
				open={exportColumnView}
				setClose={() => setExportColumnView(false)}
				language={language}
				client={client}
				pageKey={'RStockTake_DetailedExport'}
				sections={exportColumnSections}
				onGenerate={onExportColumnsGenerate}
			/>
		</div>
	)
}

const MYSQL_DATE_RE = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])(?:[ T]([01]\d|2[0-3]):([0-5]\d))?/;
const DISPLAY_DATE_RE = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

function toDisplayDate(value) {
	const parts = MYSQL_DATE_RE.exec(value);
	if (!parts) return moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
	return `${parts[3]}/${parts[2]}/${parts[1]}`;
}

function toDisplayTime(value) {
	const parts = MYSQL_DATE_RE.exec(value);
	if (!parts || !parts[4]) return moment(value, 'YYYY-MM-DD HH:mm:ss').format('hh:mmA');
	const hour24 = parseInt(parts[4], 10);
	const meridiem = hour24 < 12 ? 'AM' : 'PM';
	const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
	return `${hour12 < 10 ? '0' + hour12 : hour12}:${parts[5]}${meridiem}`;
}

function toIsoDate(value) {
	const parts = DISPLAY_DATE_RE.exec(value);
	if (!parts) return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');
	return `${parts[3]}-${parts[2]}-${parts[1]}`;
}

function toExpiryDate(value) {
	const parts = MYSQL_DATE_RE.exec(value);
	if (!parts) {
		return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY') === '1970' ? '-' : moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
	}
	if (parts[1] === '1970') return '-';
	return `${parts[3]}/${parts[2]}/${parts[1]}`;
}

function StockTakeTableSkeleton({ classes, columnCount, rowCount }) {
	return (
		<Paper elevation={1}>
			<div className={classes.skeletonToolbar}>
				<Skeleton variant="text" width={180} height={28} animation="wave" />
				<div className={classes.skeletonToolbarActions}>
					<Skeleton variant="rect" width={120} height={24} animation="wave" />
					<Skeleton variant="circle" width={28} height={28} animation="wave" />
					<Skeleton variant="circle" width={28} height={28} animation="wave" />
				</div>
			</div>
			<div className={classes.skeletonTableHeader}>
				{[...Array(columnCount)].map((_, index) => (
					<Skeleton key={index} className={classes.skeletonCell} variant="text" height={20} animation="wave" />
				))}
			</div>
			{[...Array(rowCount)].map((_, rowIndex) => (
				<div key={rowIndex} className={classes.skeletonRow}>
					{[...Array(columnCount)].map((_, index) => (
						<Skeleton key={index} className={classes.skeletonCell} variant="text" height={16} animation="wave" />
					))}
				</div>
			))}
		</Paper>
	);
}

function QtyEditField({ field, valuesRef, className }) {
	const [value, setValue] = useState(valuesRef.current[field] || '');
	return (
		<TextField
			type="number"
			size="small"
			className={className}
			value={value}
			onChange={(e) => {
				setValue(e.target.value);
				valuesRef.current[field] = e.target.value;
			}}
		/>
	);
}

function CheckinTableReportButton({ onGenerateReport }) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="addnew">
					<AssessmentIcon />
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}

function buildExportColumnSections(language, hasBranch) {
	return [
		{
			label: language.visit_header_info,
			columns: [
				{ key: 'checkin_date', label: language.check_in_date },
				{ key: 'agent_code', label: language.agent_code },
				{ key: 'agent_name', label: language.agent_name },
			]
		},
		{
			label: language.sheet_header_info,
			columns: [
				{ key: 'outlet_code', label: language.outlet_code },
				{ key: 'outlet_name', label: language.outlet_name },
				{ key: 'outlet_category', label: language.outlet_category },
				{ key: 'outlet_chain', label: language.outlet_chain },
				{ key: 'outlet_area', label: language.outlet_area },
				...(hasBranch ? [{ key: 'branch', label: language.branch }] : []),
			]
		},
		{
			label: language.product_info_columns,
			columns: [
				{ key: 'item_code', label: language.item_code, locked: true },
				{ key: 'item_name', label: language.item_name, locked: true },
				{ key: 'item_barcode', label: language.item_barcode },
				{ key: 'item_category', label: language.item_category },
				{ key: 'item_brand', label: language.item_brand },
				{ key: 'uom', label: language.uom },
				{ key: 'uom_barcode', label: language.uom_barcode },
			]
		},
		{
			label: language.stock_data_columns,
			columns: [
				{ key: 'stock_take_id', label: language.stock_take_id },
				{ key: 'current_qty', label: language.current_qty, locked: true },
				{ key: 'proposed_qty', label: language.proposed_qty, locked: true },
				{ key: 'top_up_qty', label: language.top_up_qty },
				{ key: 'return_qty', label: language.return_qty },
				{ key: 'transfer_qty', label: language.transfer_qty },
				{ key: 'expiry_date', label: language.expiry_date },
				{ key: 'listing', label: language.listing },
				{ key: 'rsp', label: language.rsp },
				{ key: 'sos', label: language.sos },
				{ key: 'shelf_level', label: language.shelf_level },
				{ key: 'note', label: language.note },
				{ key: 'remark', label: language.remark },
			]
		}
	];
}
